<footer class="footer" [style]="styles().footer">
  <div class="container">
    <div class="grid-x">
      <div class="cell medium-6">
        <address>
          @if (address()) {
            <div data-testid="address" class="address-item">
              <i class="icon icon-map" [style]="styles().contactIcons"></i>
              {{ address() }}<br/>
              {{ address_line_2() }}<br/>
            </div>
          }
          @if (phone()) {
            <div data-testid="phone" class="address-item">
              <i class="icon icon-phone" [style]="styles().contactIcons"></i>
              <a [href]="'tel:'+ phone()">{{ phone() }}</a><br />
            </div>
          }
          @if (email()) {
            <div data-testid="email" class="address-item">
              <i class="icon icon-mail" [style]="styles().contactIcons"></i>
              <a [href]="'mailto:'+email()">{{ email() }}</a>
            </div>
          }
        </address>
      </div>
      <div class="cell medium-6">
        <div class="footer__social-links">
          @if (facebook()) {
            <a data-testid="facebook" [href]="facebook()" target="_blank" title="Facebook link"><i class="icon icon-facebook" [style]="styles().socialLinks"></i></a>
          }
          @if (twitter()) {
            <a data-testid="twitter" [href]="twitter()" target="_blank" title="Twitter link"><i class="icon icon-twitter-x" [style]="styles().socialLinks"></i></a>
          }
          @if (instagram()) {
            <a data-testid="instagram" [href]="instagram()" target="_blank" title="Instagram link"><i class="icon icon-instagram" [style]="styles().socialLinks"></i></a>
          }
          @if (youtube()) {
            <a data-testid="youtube" [href]="youtube()" target="_blank" title="Youtube link"><i class="icon icon-youtube" [style]="styles().socialLinks"></i></a>
          }
          @if (linkedin()) {
            <a data-testid="linkedin" [href]="linkedin()" target="_blank" title="LinkedIn link"><i class="icon icon-linkedin" [style]="styles().socialLinks"></i></a>
          }
        </div>
      </div>
    </div>
    <div class="grid-x">
      <div class="cell large-8 medium-6">
        <p class="copyright">
          @let i18nCopyrightText = i18n.get(copyright_text());
          @if (i18nCopyrightText) {
            <span data-testid="copyright">&copy; {{ i18nCopyrightText }}</span>
          }
          @let i18nLink1Text = i18n.get(link_1_text());
          @if (i18nLink1Text && link_1_url()) {
            <a data-testid="link1" href="{{ link_1_url() }}">{{ i18nLink1Text }}</a>
          }
          @let i18nLink2Text = i18n.get(link_2_text());
          @if (i18nLink2Text && link_2_url()) {
            <a data-testid="link2" href="{{ link_2_url() }}">{{ i18nLink2Text }}</a>
          }
          @let i18nLink3Text = i18n.get(link_3_text());
          @if (i18nLink3Text && link_3_url()) {
            <a data-testid="link3" href="{{ link_3_url() }}">{{ i18nLink3Text }}</a>
          }
        </p>
      </div>
      <div class="cell large-4 medium-6">
        <div data-testid="powered-by" class="footer__logo" [attr.aria-label]="poweredBy + ' Rouse'" [style]="styles().footerLogo">
          {{poweredBy}}
          <i class="icon icon-rouse"></i>
        </div>
      </div>
    </div>
  </div>
</footer>